module.exports = __webpack_public_path__ + "static/img/23.4a7d7aa3.jpg";